import {
  Button,
  Css,
  DateRangeField,
  FieldGroup,
  FormLines,
  HasIdAndName,
  MultiSelectField,
  useTestIds,
} from "@homebound/beam";
import { useState } from "react";
import { DateOperation } from "src/generated/graphql-types";
import { InvoicesFilter } from "../utils";

interface InvoiceFilterModalProps {
  filterOptions?: {
    status: HasIdAndName[];
    address: HasIdAndName[];
    markets: HasIdAndName[];
  };
  filter: InvoicesFilter;
  setFilter: (filter: InvoicesFilter) => void;
  close: () => void;
}

export function InvoiceFilterModal({
  filterOptions = { status: [], address: [], markets: [] },
  filter,
  setFilter,
  close,
}: InvoiceFilterModalProps) {
  const tid = useTestIds({});
  const [modalFilter, setModalFilter] = useState<InvoicesFilter>(filter);

  const onSubmit = () => {
    setFilter(modalFilter);
    close();
  };

  const { status, address, markets } = filterOptions;

  return (
    <div {...tid.modal}>
      <FormLines>
        <FieldGroup>
          <MultiSelectField
            onSelect={(val) =>
              setModalFilter((prevState) => ({
                ...prevState,
                address: val.nonEmpty ? val : [],
              }))
            }
            label="Address"
            options={address}
            values={modalFilter.address}
          />
          <MultiSelectField
            onSelect={(val) => {
              return setModalFilter((prevState) => ({
                ...prevState,
                status: val.nonEmpty ? val : [],
              }));
            }}
            label="Status"
            options={status}
            values={modalFilter.status}
            data-testid="status"
          />
          <MultiSelectField
            onSelect={(val) => {
              return setModalFilter((prevState) => ({
                ...prevState,
                marketId: val.nonEmpty ? val : undefined,
              }));
            }}
            label="Market"
            options={markets}
            values={modalFilter.marketId ?? []}
          />
        </FieldGroup>
        <FieldGroup>
          <DateRangeField
            value={modalFilter.dueDateRange?.value}
            onChange={(val) => {
              val &&
                setModalFilter((prevState) => ({
                  ...prevState,
                  dueDateRange: {
                    value: { to: val.to, from: val.from },
                    op: DateOperation.Between,
                  },
                }));
            }}
            label="Due date range"
            hideCalendarIcon={true}
            placeholder="Due date range"
          />
          <DateRangeField
            value={modalFilter.paidDateRange?.value}
            onChange={(val) => {
              val &&
                setModalFilter((prevState) => ({
                  ...prevState,
                  paidDateRange: {
                    value: { to: val.to, from: val.from },
                    op: DateOperation.Between,
                  },
                }));
            }}
            label="Paid date range"
            hideCalendarIcon={true}
            placeholder="Paid date range"
          />
        </FieldGroup>
      </FormLines>
      <div css={Css.df.gap1.jcfe.mtPx(80).$}>
        <Button variant="tertiary" label="Cancel" onClick={close} />
        <Button label="Apply" onClick={onSubmit} />
      </div>
    </div>
  );
}
